import { convolutionPixelShader } from "babylonjs/Shaders/convolution.fragment";
import Vue from "vue";
import Data from "../application/Data";
import DataUtils from "./DataUtils";
import Utils from "./Utils";

/* The `FiltersUtils` class in TypeScript provides methods for creating, setting, and updating filters
for products based on user input and configuration settings. */
export default class FiltersUtils {
    /* The above code is a TypeScript static method that is used to create and set filters for products
    based on the provided view. Here is a summary of what the code does: */
    static createFilters(view:string){
        let data:any = {};

        //FILTERS
        if (Data.data.config.views[view].filters){
            Data.data.config.views[view].filters.filter((filter: string) => {
                let filterData: any;

                filterData = Utils.copy(Data.data[filter]);

                data[filter] = filterData;
            })
        }

        //APPLIED FILTERS
        if (Data.data.config.views[view].appliedFilters) {
            let filter:string;
            for (filter in Data.data.config.views[view].appliedFilters){
                let filterData: any;

                if (Data.data.oldDataMode == true) {
                    if (filter == "markets" || filter == "internationalMarkets") {
                        filterData = Utils.copy(Data.data.markets.international);

                        if (filter == "markets") {
                            filterData = Utils.copy(Data.data.markets[Data.data.country]);
                        }
                    } else {
                        filterData = Utils.copy(Data.data[filter]);
                    }
                }else{
                    filterData = Utils.copy(Data.data[filter]);
                }


                let filterConfig: any = Data.data.config.filters[filter];
                if (!filterConfig) {
                    // console.log("");
                    // console.log("---------------------------------");
                    // console.log("/!\\ Could not find config data for filter " + filter);
                    // console.log("---------------------------------");
                    // console.log("");
                } else {
                    let appliedFilterData: any = Data.data.config.views[view].appliedFilters[filter];

                    //TREE VALUES
                    if (filterConfig.type == "treeValues") {
                        let appliedFilterValues: any = appliedFilterData.values;

                        if (filter == "markets" && Data.data.oldDataMode == true){
                            appliedFilterValues = appliedFilterData["values-" + Data.data.country];
                        }


                        let a: number = appliedFilterValues.length;
                        for(let i=0; i<a; i++){
                            let b = filterData.length;
                            for(var j=0; j<b; j++){
                                if (appliedFilterValues[i].id == filterData[j].id){
                                    filterData[j].selected = true;
                                }
                            }

                            if (appliedFilterValues[i].sub){
                                let b = appliedFilterValues[i].sub.length;
                                for (var j = 0; j < b; j++) {
                                    let c:number = filterData.length;
                                    for (var k = 0; k < c; k++) {
                                        if (filterData[k].sub){
                                            let d: number = filterData[k].sub.length;
                                            for(let l=0; l<d; l++){
                                                if (appliedFilterValues[i].sub[j].id == filterData[k].sub[l].id){
                                                    filterData[k].sub[l].selected = true;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    } else if (filterConfig.type == "array"){
                        let appliedFilterValues: any = appliedFilterData.values;

                        let a: number = filterData.length;
                        for(let i=0; i<a; i++){
                            if (appliedFilterValues.indexOf(filterData[i].id) != -1) filterData[i].selected = true;
                        }
                    } else if (filterConfig.type == "value"){
                        filterData = appliedFilterData.value;
                    } else if (filterConfig.type == "multipleValues") {
                        filterData.selected = [];
                    } else if (filterConfig.type == "numberRange") {

                    } else if (filterConfig.type == "datesRange") {

                    }
                }

                data[filter] = filterData;
            }
        }


        return data;
    }
    /**
     * The function `setFilters` in TypeScript is responsible for applying search and filter
     * functionality to products based on user input and configuration settings.
     * @param {string} [filter=null] - The `filter` parameter in the `setFilters` function is used to
     * specify a particular filter to apply when filtering products. If a `filter` value is provided,
     * the function checks if the filter configuration exists in the data and if it is a master filter.
     * If it is a master filter,
     * @returns In the provided code snippet, the `setFilters` function returns different values based
     * on certain conditions:
     */
    static setFilters(filter:string=null){
        Data.data.filteredProducts = null;
        Data.data.catalogPage = 1;

        //SEARCH
        if (Data.data.catalogSearch && Data.data.catalogSearch.length >= 3 && !Data.data.catalogSearchWithFilters){
            Data.data.filteredProducts = FiltersUtils.getSearchProducts(Data.data.catalogSearch);
            return;
        }


        //FILTERS
        let view: any = Data.data.config.views[Data.data.view];
        if (!view) return;

        if (view.views) {
            return;
        }

        if (!view.filters && !view.appliedFilters) return;


        Data.data.filters = Data.data.savedFilters[Data.data.platform.id + "-" + Data.data.view];
        if (!Data.data.filters) {
            Data.data.filters = Data.data.savedFilters[Data.data.platform.id + "-" + Data.data.view] = this.createFilters(Data.data.view);
        }

        let resetNumberVlues:boolean = false;
        if(filter){
            let filterConfig: any = Data.data.config.filters[filter];
            if (filterConfig && filterConfig.master) {
                resetNumberVlues = true;
            }
        }

        Data.data.masterFilteredProducts = FiltersUtils.getFilteredProducts(Data.data.products, Data.data.filters, true);
        this.updateSlaveFilters(Data.data.filters, Data.data.masterFilteredProducts, resetNumberVlues);
        Data.data.filteredProducts = FiltersUtils.getFilteredProducts(Data.data.masterFilteredProducts, Data.data.filters);

        //SEARCH WITH FILTERS
        if (Data.data.catalogSearch && Data.data.catalogSearch.length >= 3 && Data.data.catalogSearchWithFilters) {
            Data.data.filteredProducts = FiltersUtils.getSearchProducts(Data.data.catalogSearch, Data.data.filteredProducts);
            return;
        }
    }
    /**
     * The function `getSearchProducts` searches for products based on a given search string and
     * returns the matching results.
     * @param {string} search - The `search` parameter is a string that represents the search query
     * entered by the user to find products. This function searches for products based on this search
     * query.
     * @param {any} [products] - The `getSearchProducts` function takes two parameters: `search` and
     * `products`.
     * @returns The `getSearchProducts` function returns an array of products that match the search
     * criteria provided in the `search` parameter. The function searches for products based on their
     * name, glass drawing, or base products, and filters the results based on whether the virtual
     * glass mode is enabled (`Data.data.VGMode`). The final array of matching products is sorted
     * before being returned.
     */
    static getSearchProducts(search:string, products?:any){
        let results: any = [];

        let field: string = String(search).toLowerCase();

        if (!products) products = Data.data.products;

        let str: string;
        for (str in products) {
            let product: any = products[str];
            product.colorIndex = 0;
            product.infoDisplay = false;



            //NAME
            let label: string = DataUtils.getProductName(product);
            if (label.toLowerCase().indexOf(field) != -1) {
                results.push(product);
            } else if (product.glassDrawing.toLowerCase().indexOf(field) != -1) {
                results.push(product);
            } else {
                for (let i = 0; i < product.baseProducts.length; i++) {
                    if (product.baseProducts[i].indexOf(field) != -1) {
                        results.push(product);
                        product.colorIndex = i;
                        break;
                    }
                }
            }
        }

        this.sortProducts(results);

        return results;
    }
    /**
     * The function `getFilteredProducts` filters products based on specified filters and returns the
     * results.
     * @param {any} products - The function `getFilteredProducts` takes in three parameters:
     * @param {any} filters - The `getFilteredProducts` function takes in three parameters:
     * @param {boolean} [onlyMasterFilters=false] - The `onlyMasterFilters` parameter is a boolean flag
     * that determines whether to apply only master filters or all filters when filtering products. If
     * set to `true`, only master filters will be applied, and if set to `false` (or not provided), all
     * filters will be considered during the filtering process
     * @returns The `getFilteredProducts` function returns an array of filtered products based on the
     * provided filters. The function first checks the filters and then iterates through the products
     * to determine which products pass the filter criteria. The filtered products are then returned as
     * an array.
     */
    static getFilteredProducts(products:any, filters: any, onlyMasterFilters:boolean=false): any {
        let results: any = [];
        if (onlyMasterFilters) results = {};
        let pool: any = {};

        // console.log("");
        // console.log("---------------------------------");
        // console.log("FILTERS");
        // console.log("---------------------------------");
        // console.log("");


        let numFilters: number = 0;
        let usedFilters: any = {};

        // if (!onlyMasterFilters){
        //     console.log("");
        //     console.log("MASTER FILTERS --------------------------");
        // }


        let str: string;
        for (str in filters) {
            let filterData: any = filters[str];
            let filterConfig: any = Data.data.config.filters[str];

            if (onlyMasterFilters && !filterConfig.master) continue;
            else if (!onlyMasterFilters && filterConfig.master) continue;

            pool[str] = [];

            //if (!onlyMasterFilters) console.log(str);

            if (filterConfig.type == "value") {
                if (filterData == true && !usedFilters[str]) {
                    usedFilters[str] = filterData;
                    numFilters ++;
                    //break;
                }
            }else if(filterConfig.type == "multipleValues") {
                if (filterData.selected.length > 0 && !usedFilters[str]) {
                    usedFilters[str] = filterData.selected;
                    numFilters++;
                    //break;
                }
            }else if(filterConfig.type == "array") {
                let a: number = filterData.length;
                for (let i = 0; i < a; i++) {
                    if (filterData[i].selected == true && !usedFilters[str]) {
                        usedFilters[str] = filterData;
                        numFilters ++;
                        //break;
                    }
                }
            } else if (filterConfig.type == "numberRange") {
                if (filterData.min != filterData.range[0] || filterData.max != filterData.range[1]){
                    usedFilters[str] = filterData;
                    numFilters++;
                }
            }else if (filterConfig.type == "treeValues"){
                let a: number = filterData.length;
                for (let i = 0; i < a; i++) {
                    if (filterData[i].selected == true && !usedFilters[str]) {
                        usedFilters[str] = filterData;
                        numFilters ++;
                        break;
                    }/*else{
                        if (filterData[i].sub){
                            let b: number = filterData[i].sub.length;
                            for (let j = 0; j < b; j++) {
                                if (filterData[i].sub[j].selected == true) {
                                    usedFilters[str] = filterData;
                                    numFilters ++;
                                    break;
                                }
                            }
                        }
                    }*/
                }
            } else if (filterConfig.type == "datesRange") {
                if (filterData.startDate != filterData.dates[0] || filterData.endDate < filterData.dates[filterData.dates.length - 1]){
                    usedFilters[str] = filterData;
                    numFilters++;
                }
            }
        }

        //if (onlyMasterFilters)  console.log(usedFilters);
        for (str in usedFilters) {
            //if(!onlyMasterFilters) console.log(str);
        }



        //console.log(numFilters);

        //IF NO FILTERS SELECTED THEN ALL THE PRODUCTS ARE DISPLAYED
        if (numFilters == 0){
            for (str in products) {
                if (!onlyMasterFilters) results.push(products[str]);
                else results[str] = products[str];
            }

            if (!onlyMasterFilters) {
                this.sortProducts(results);
            }

            return results;
        }



        //GETTING FILTERED PRODUCTS
        let str2: string;

        for (str2 in products) {
            let product: any = products[str2];
            product.colorIndex = 0;
            product.infoDisplay = false;

            let filtersPassed: number = 0;

            for (str in usedFilters) {
                let filterData: any = usedFilters[str];
                let filterConfig: any = Data.data.config.filters[str];
                let field: any = product[filterConfig.field];


                //CHECK FIELD ON BASEPRODUCT
                if (filterConfig.field.indexOf("baseProduct") == 0) {
                    let bpField: string = filterConfig.field.split(".")[1];

                    let a: number = product.baseProducts.length;
                    for(let i=0; i<a; i++){
                        let bp:any = Data.data.baseProducts[product.baseProducts[i]];

                        if(!bp) continue;

                        field = bp[bpField];

                        if (bpField == "plsProduct"){
                            let plsField: string = filterConfig.field.split(".")[2];
                            let pls: any = Data.data.plsProducts[product.baseProducts[i]];

                            if (!pls) continue;

                            for (let j = 0; j < pls.length; j++){
                                field = pls[j][plsField];

                                if (field == null || field == undefined) {
                                    //console.log("/!\\ Could not find field : " + filterConfig.field + " in product : " + product.id + " / " + product.baseProducts[i]);
                                    continue;
                                }

                                //VALUE
                                if (filterConfig.type == "value") {
                                    //console.log(field + " : " + filterConfig.value);
                                    if (this.filterOnValue(field, filterData, filterConfig.value, product, pool[str]) == true) filtersPassed++;

                                    //MULTIPLE VALUES
                                } else if (filterConfig.type == "multipleValues") {
                                    if (this.filterOnMultipleValues(field, filterData, product, pool[str]) == true) filtersPassed++;

                                    //ARRAY
                                } else if (filterConfig.type == "array") {
                                    if (this.filterOnArray(field, filterData, product, pool[str]) == true) filtersPassed++;

                                    //TREE VALUES
                                } else if (filterConfig.type == "treeValues") {
                                    let bpindex: number = -1;
                                    if (filterConfig.field == "baseProduct.colors") bpindex = i;
                                    if (this.filterOnTreeValues(field, filterData, product, pool[str], bpindex) == true) filtersPassed++;

                                    //NUMBER RANGE
                                } else if (filterConfig.type == "numberRange") {
                                    if (this.filterOnNumberRange(str, field, filterData, product, pool[str]) == true) filtersPassed++;

                                    //DATES RANGE
                                } else if (filterConfig.type == "datesRange") {
                                    if (this.filterOnDatesRange(field, filterData, product, pool[str]) == true) filtersPassed++;
                                }
                            }
                        }else{
                            if (field == null || field == undefined) {
                                //console.log("/!\\ Could not find field : " + filterConfig.field + " in product : " + product.id + " / " + product.baseProducts[i]);
                                continue;
                            }

                            //VALUE
                            if (filterConfig.type == "value") {
                                //console.log(field + " : " + filterConfig.value);
                                if (this.filterOnValue(field, filterData, filterConfig.value, product, pool[str]) == true) filtersPassed++;

                                //MULTIPLE VALUES
                            } else if (filterConfig.type == "multipleValues") {
                                if (this.filterOnMultipleValues(field, filterData, product, pool[str]) == true) filtersPassed++;

                                //ARRAY
                            } else if (filterConfig.type == "array") {
                                if (this.filterOnArray(field, filterData, product, pool[str]) == true) filtersPassed++;

                                //TREE VALUES
                            } else if (filterConfig.type == "treeValues") {
                                let bpindex: number = -1;
                                if (filterConfig.field == "baseProduct.colors") bpindex = i;
                                if (this.filterOnTreeValues(field, filterData, product, pool[str], bpindex) == true) filtersPassed++;

                                //NUMBER RANGE
                            } else if (filterConfig.type == "numberRange") {
                                if (this.filterOnNumberRange(str, field, filterData, product, pool[str]) == true) filtersPassed++;

                                //DATES RANGE
                            } else if (filterConfig.type == "datesRange") {
                                if (this.filterOnDatesRange(field, filterData, product, pool[str]) == true) filtersPassed++;
                            }
                        }
                    }

                //CHECK FIELD ON PRODUCT
                }else{
                    if (field == null || field == undefined) {
                        //console.log("/!\\ Could not find field : " + filterConfig.field + " in product : " + product.id);
                        continue;
                    }

                    //VALUE
                    if (filterConfig.type == "value") {
                        if (this.filterOnValue(field, filterData, filterConfig.value, product, pool[str]) == true) filtersPassed ++;

                    //ARRAY
                    } else if (filterConfig.type == "array") {
                        if (this.filterOnArray(field, filterData, product, pool[str]) == true) filtersPassed ++;

                    //MULTIPLE VALUES
                    } else if (filterConfig.type == "multipleValues") {
                        if (this.filterOnMultipleValues(field, filterData, product, pool[str]) == true) filtersPassed++;

                    //TREE VALUES
                    } else if (filterConfig.type == "treeValues") {
                        if (this.filterOnTreeValues(field, filterData, product, pool[str], -1) == true) filtersPassed ++;

                    //NUMBER RANGE
                    }else if (filterConfig.type == "numberRange") {
                        if (this.filterOnNumberRange(str, field, filterData, product, pool[str]) == true) filtersPassed++;

                    //DATES RANGE
                    } else if (filterConfig.type == "datesRange") {
                        if (this.filterOnDatesRange(field, filterData, product, pool[str]) == true) filtersPassed++;
                    }
                }

                //console.log(str);
                //console.log(filterData);
                //console.log(filterConfig);
            }

            if (!onlyMasterFilters && filtersPassed == numFilters){
                results.push(product);
            }else if (onlyMasterFilters && filtersPassed == numFilters) {
                results[str2] = product;
            }
        }

        //console.log(pool);



        if (!onlyMasterFilters){
            this.sortProducts(results);
        }

        return results;
    }
    /**
     * The function `updateSlaveFilters` in TypeScript updates slave filters based on different types
     * of filter configurations.
     * @param {any} filters - The `updateSlaveFilters` function takes in several parameters:
     * @param {any} products - It looks like you were about to provide some information about the
     * `products` parameter, but the message got cut off. Could you please provide more details or let
     * me know how I can assist you further with this code snippet?
     * @param {boolean} [resetNumberVlues=false] - The `resetNumberVlues` parameter is a boolean flag
     * that determines whether to reset number values in the filters. By default, it is set to `false`,
     * but you can set it to `true` if you want to reset number values.
     */
    static updateSlaveFilters(filters: any, products: any, resetNumberVlues:boolean=false){
        let str: string;
        for (str in filters) {
            let filterData: any = filters[str];
            let filterConfig: any = Data.data.config.filters[str];

            if (!filterConfig.slave) continue;

            if (filterConfig.type == "value") {

            } else if (filterConfig.type == "multipleValues") {

            } else if (filterConfig.type == "array") {

            } else if (filterConfig.type == "numberRange") {
               this.updateNumberRange(filters, str, filterConfig, products, resetNumberVlues);
            } else if (filterConfig.type == "treeValues") {
                let a: number = filterData.length;
                for (let i = 0; i < a; i++) {
                    filterData[i].enabled = false;
                    let exists:boolean = false;

                    filterData[i].enabled = this.existsInProductsTreeValues(filterData[i].id, filterConfig, products);

                    let b: number = filterData[i].sub.length;
                    for (let j = 0; j < b; j++) {
                        filterData[i].sub[j].enabled = this.existsInProductsTreeValues(filterData[i].sub[j].id, filterConfig, products);
                        if (!exists && filterData[i].sub[j].enabled) exists = true;
                    }

                    if (exists) filterData[i].enabled = true;
                }
            } else if (filterConfig.type == "datesRange") {

            }
        }
    }
    /**
     * The function `updateNumberRange` calculates the minimum and maximum values of a specified field
     * in a collection of products and updates the corresponding filter range values accordingly.
     * @param {any} filters - The `updateNumberRange` function takes in several parameters:
     * @param {string} filter - The `filter` parameter in the `updateNumberRange` function is used to
     * specify the key in the `filters` object that will be updated with the minimum and maximum values
     * calculated from the `products` array.
     * @param {any} filterConfig - The `updateNumberRange` function takes in several parameters to
     * update the number range in the filters object based on the products data. Here's a breakdown of
     * the parameters:
     * @param {any} products - The `updateNumberRange` function takes in several parameters to update
     * the number range in the filters object based on the values in the products array. Here's a
     * breakdown of the parameters:
     * @param {boolean} [resetNumberVlues=false] - The `resetNumberValues` parameter in the
     * `updateNumberRange` function is a boolean parameter with a default value of `false`. When
     * `resetNumberValues` is set to `true`, it will reset the range values to the minimum and maximum
     * values found in the products data. If it is
     */
    private static updateNumberRange(filters: any, filter: string, filterConfig: any, products: any, resetNumberVlues:boolean=false){
        let min:number = 1000000;
        let max:number = 0;

        let str: string;
        for (str in products) {
            let product: any = products[str];

            let field: any = this.getProductField(filterConfig.field, product);

            if (!field) continue;

            if (max < field) max = field;
            if (min > field) min = field;
        }

        filters[filter].min = min;
        filters[filter].max = max;

        if (!resetNumberVlues){
            if (filters[filter].range[0] < min) Vue.set(filters[filter].range, 0, min);
            if (filters[filter].range[1] > max) Vue.set(filters[filter].range, 1, max);
        }else{
            Vue.set(filters[filter].range, 0, min);
            Vue.set(filters[filter].range, 1, max);
        }
    }
    /**
     * The function `existsInProductsTreeValues` checks if a specific ID exists within a nested tree
     * structure of products based on a given filter configuration.
     * @param {string} id - The `id` parameter is a string representing the unique identifier of a
     * product or item that you are searching for within the `products` data structure. The function
     * `existsInProductsTreeValues` is designed to check if this `id` exists within the nested
     * structure of the `products` object based
     * @param {any} filterConfig - The `filterConfig` parameter is an object that contains
     * configuration settings for filtering products. It likely includes information such as the field
     * to filter on and other filter criteria.
     * @param {any} products - The `products` parameter in the `existsInProductsTreeValues` function is
     * expected to be an object containing product data. Each product in the `products` object should
     * have a structure that includes fields and subfields. The function iterates over the products to
     * check if a specific `id` exists
     * @returns The function `existsInProductsTreeValues` returns a boolean value - `true` if the `id`
     * exists in the specified structure within the `products` object based on the provided
     * `filterConfig`, and `false` otherwise.
     */
    private static existsInProductsTreeValues(id: string, filterConfig: any, products: any){
        let str: string;
        for (str in products) {
            let product: any = products[str];

            let field: any = this.getProductField(filterConfig.field, product);

            if (!field) continue;

            let a:number = field.length;
            for(let i=0; i<a; i++){
                let b: number = field[i].sub.length;

                for (let j = 0; j < b; j++) {
                    if (field[i].sub[j].id == id) return true;
                }

                if (field[i].id == id) return true;
            }
        }

        return false;
    }
    /**
     * The function `getProductField` retrieves a specific field value from a product object, handling
     * nested fields for base products and related data.
     * @param {string} field - The `field` parameter is a string that represents the field you want to
     * retrieve from the `product` object. It could be a direct field of the `product` object or a
     * nested field that requires accessing related objects like `baseProducts` and `plsProducts`. The
     * function `getProductField
     * @param {any} product - The `product` parameter in the `getProductField` function is an object
     * that represents a product. It contains various fields and values related to the product, such as
     * its name, price, description, and other attributes. The function is designed to retrieve a
     * specific field value from the product object based
     * @returns The function `getProductField` is returning the value of the specified field from the
     * product object. If the field starts with "baseProduct", it will retrieve the corresponding field
     * value from the base product or the pls product if the field is nested further.
     */
    private static getProductField(field:string, product:any){
        let fieldData:any = product[field];

        //CHECK FIELD ON BASEPRODUCT
        if (field.indexOf("baseProduct") == 0) {
            let bpField: string = field.split(".")[1];

            let a: number = product.baseProducts.length;
            for (let i = 0; i < a; i++) {
                let bp: any = Data.data.baseProducts[product.baseProducts[i]];

                if (!bp) continue;

                fieldData = bp[bpField];

                if (bpField == "plsProduct") {
                    let plsField: string = field.split(".")[2];
                    let pls: any = Data.data.plsProducts[product.baseProducts[i]];

                    if (!pls) continue;

                    fieldData = pls[plsField];
                }

            }
        }

        return fieldData;
    }
    /**
     * The function `sortProducts` sorts an array of products based on a specified field and order
     * criteria.
     * @param {any} results - The `results` parameter in the `sortProducts` function is an array of
     * objects representing products that need to be sorted based on a specified field and order
     * criteria. The function sorts the products in place according to the specified field and order
     * direction (ascending or descending).
     */
    private static sortProducts(results:any){
        let orderData: any = Data.data.config.productsOrder[Data.data.productsOrder];
        if (orderData.field) {
            results.sort((a, b) => {
                let type: any = typeof a[orderData.field];

                if(orderData.field == "name"){
                    a.name = DataUtils.getProductName(a);
                    b.name = DataUtils.getProductName(b);
                }

                if (type == "string") {
                    if (orderData.ascendant) return a[orderData.field].localeCompare(b[orderData.field]);
                    else return b[orderData.field].localeCompare(a[orderData.field]);
                } else {
                    if (orderData.ascendant) return a[orderData.field] - b[orderData.field];
                    else return b[orderData.field] - a[orderData.field];
                }
            });
        }
    }
    /**
     * The function filters products based on a specific field value and adds the product ID to a pool
     * if it meets the criteria.
     * @param {any} field - The `field` parameter is the field that you want to filter on in the
     * `product` object. It is compared with the `filterValue` to determine if the `product` should be
     * included in the filtered result.
     * @param {any} filterData - The `filterData` parameter is used to pass the data that needs to be
     * filtered based on a specific value.
     * @param {any} filterValue - The `filterValue` parameter is the value that you want to filter on.
     * In the `filterOnValue` function, it is compared with the `field` parameter to determine if the
     * `product` should be included in the `pool` based on the condition specified in the function.
     * @param {any} product - The `product` parameter in the `filterOnValue` function represents an
     * object that contains information about a product.
     * @param {any} pool - The `pool` parameter seems to be an array that stores the IDs of products
     * that have passed a certain filter condition. The `filterOnValue` function checks if a given
     * `product` meets the filter condition based on the `field` and `filterValue` provided. If the
     * condition is met
     * @returns The method `filterOnValue` returns a boolean value - `true` if the condition `field ==
     * filterValue && pool.indexOf(product.id) == -1` is met and the product id is successfully added
     * to the `pool` array, otherwise it returns `false`.
     */
    private static filterOnValue(field:any, filterData:any, filterValue:any, product:any, pool:any) {
        if(field == filterValue && pool.indexOf(product.id) == -1){
            pool.push(product.id);

            return true;
        }

        return false;
    }
    /**
     * The function filters on multiple values based on specified criteria and returns true if a match
     * is found.
     * @param {any} field - The `field` parameter is the field that you want to filter on. It could be
     * a string representing a field in your data that you want to check for multiple values.
     * @param {any} filterData - An array containing multiple values to filter on.
     * @param {any} product - The `product` parameter in the `filterOnMultipleValues` function seems to
     * represent an object that contains information about a product. It likely has properties such as
     * `id`, `name`, `price`, etc. This object is being used to check if a certain field matches any of
     * the filter data
     * @param {any} pool - The `pool` parameter in the `filterOnMultipleValues` function seems to be an
     * array that stores unique identifiers of products. It is used to keep track of products that have
     * already passed the filtering criteria to avoid duplicates.
     * @returns a boolean value - true or false.
     */
    private static filterOnMultipleValues(field: any, filterData: any, product: any, pool: any){
        let a: number = filterData.length;
        for (let i = 0; i < a; i++) {
            if (field.toLowerCase().indexOf(filterData[i].toLowerCase()) != -1 && pool.indexOf(product.id) == -1) {
                pool.push(product.id);

                return true;
            }
        }

        return false;
    }
    /**
     * The function `filterOnArray` filters an array based on certain conditions and returns true if a
     * match is found, otherwise false.
     * @param {any} field - The `field` parameter is an array containing the values to filter on.
     * @param {any} filterData - The `filterData` parameter is an array containing objects with
     * properties such as `selected` and `id`.
     * @param {any} product - The `product` parameter in the `filterOnArray` function seems to
     * represent an object that contains information about a product. It is used to check if the
     * product meets certain criteria based on the `field`, `filterData`, and `pool` parameters.
     * @param {any} pool - The `pool` parameter in the `filterOnArray` function seems to be an array
     * that is used to store unique product IDs. The function checks if a product ID is not already
     * present in the `pool` array before adding it. If the product ID is not present in the `pool`
     * @returns a boolean value - either `true` or `false`.
     */
    private static filterOnArray(field: any, filterData: any, product: any, pool: any){
        let a: number = filterData.length;
        for (let i = 0; i < a; i++) {
            if (filterData[i].selected == true && field.indexOf(filterData[i].id) != -1 && pool.indexOf(product.id) == -1) {
                pool.push(product.id);

                return true;
            }
        }

        return false;
    }
    /**
     * The function `filterOnTreeValues` filters data based on selected values in a tree structure and
     * updates a pool array with product IDs.
     * @param {any} field - The `field` parameter in the `filterOnTreeValues` function seems to
     * represent an array of objects. These objects likely have an `id` property that is used for
     * comparison within the function.
     * @param {any} filterData - The `filterOnTreeValues` function you provided seems to be filtering
     * data based on certain conditions. The `filterData` parameter seems to be an array containing
     * objects with properties like `selected`, `id`, and `sub`. The function iterates over this array
     * to check for selected items and their
     * @param {any} product - The `product` parameter in the `filterOnTreeValues` function represents
     * the product object that is being filtered based on the `field` and `filterData` parameters. The
     * function checks if certain criteria are met in the `field` and `filterData` arrays to determine
     * if the product should
     * @param {any} pool - The `pool` parameter in the `filterOnTreeValues` function is an array that
     * stores unique identifiers of products. The function checks if a product's identifier is already
     * in the `pool` array before adding it. If the identifier is not present in the `pool` array, the
     * product's
     * @param {number} bpIndex - The `bpIndex` parameter in the `filterOnTreeValues` function is a
     * number that represents the color index of a product. It is used to set the color index of a
     * product if a certain condition is met within the function. If `bpIndex` is not provided or is
     * set to
     * @returns The function `filterOnTreeValues` returns a boolean value - `true` if a condition is
     * met and `false` if not.
     */
    private static filterOnTreeValues(field: any, filterData: any, product: any, pool: any, bpIndex:number=-1) {
        let a: number = filterData.length;
        let isSubSelected: boolean = false;

        for (let i = 0; i < a; i++) {
            if (filterData[i].selected == true) {
                if (filterData[i].sub) {
                    let b: number = filterData[i].sub.length;
                    for (let j = 0; j < b; j++) {
                        if (filterData[i].sub[j].selected == true) {
                            isSubSelected = true;
                            break;
                        }
                    }
                }
            }
        }

        if (isSubSelected == true) {
            let a: number = filterData.length;
            for (let i = 0; i < a; i++) {
                if (filterData[i].selected == true) {
                    let b: number = field.length;
                    for (let j = 0; j < b; j++) {
                        if (field[j].id == filterData[i].id) {
                            if (field[j].sub && filterData[i].sub) {
                                let c: number = field[j].sub.length;
                                for (let k = 0; k < c; k++) {
                                    let d: number = filterData[i].sub.length;
                                    for (let l = 0; l < d; l++) {
                                        if (filterData[i].sub[l].selected == true) {
                                            if (field[j].sub[k].id == filterData[i].sub[l].id && pool.indexOf(product.id) == -1) {
                                                pool.push(product.id);
                                                if (bpIndex != -1) product.colorIndex = bpIndex;

                                                return true;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        } else {
            let a: number = filterData.length;
            for (let i = 0; i < a; i++) {
                if (filterData[i].selected == true) {
                    let b: number = field.length;
                    for (let j = 0; j < b; j++) {
                        if (field[j].id == filterData[i].id && pool.indexOf(product.id) == -1) {
                            pool.push(product.id);
                            if (bpIndex != -1) product.colorIndex = bpIndex;

                            return true;
                        }
                    }
                }
            }
        }

        return false;
    }
    /**
     * The function `filterOnNumberRange` filters a product based on a specified number range.
     * @param {string} filter - The `filter` parameter is a string that is used to specify the type of
     * filter being applied.
     * @param {any} field - The `field` parameter in the `filterOnNumberRange` function represents the
     * value that you want to filter on within a specified number range.
     * @param {any} filterData - The `filterData` parameter seems to contain a property named `range`
     * which is an array with two elements representing a number range. The function
     * `filterOnNumberRange` checks if the `field` value falls within this number range specified in
     * `filterData.range`. If the `field` value
     * @param {any} product - The `product` parameter seems to represent an object or data related to a
     * product. It is likely used within the `filterOnNumberRange` function to perform some kind of
     * filtering based on a number range.
     * @param {any} pool - The `pool` parameter seems to be unused in the `filterOnNumberRange`
     * function. It is passed as an argument but not utilized within the function body. If you have any
     * specific requirements or logic that involve the `pool` parameter, you may need to update the
     * function implementation accordingly.
     * @returns `true` if the `field` value is within the range specified in `filterData.range`,
     * otherwise it returns `false`.
     */
    private static filterOnNumberRange(filter:string, field: any, filterData: any, product: any, pool: any){
        if (!field) field = 10;

        if (field >= filterData.range[0] && field <= filterData.range[1]) return true;

        return false;
    }
    /**
     * The function `filterOnDatesRange` checks if a given date falls within a specified date range.
     * @param {any} field - The `field` parameter is the date field that you want to filter on. It
     * represents a specific date value that you want to check against the date range defined by
     * `startDate` and `endDate` in the `filterData` object.
     * @param {any} filterData - The `filterData` parameter seems to be an object containing some
     * properties.
     * @param {any} product - The `product` parameter in the `filterOnDatesRange` function seems to be
     * unused within the function itself. It's possible that the `product` parameter was intended to be
     * used for some filtering or processing logic related to the product data. If you need assistance
     * on how to incorporate the `product
     * @param {any} pool - The `pool` parameter in the `filterOnDatesRange` function appears to be
     * unused in the provided code snippet. If you need assistance with how to utilize the `pool`
     * parameter within the function or have any other questions, feel free to ask!
     * @returns The function `filterOnDatesRange` returns `true` if the date specified by the `field`
     * parameter falls within the range defined by `startDate` and `endDate` in the `filterData`
     * object. Otherwise, it returns `false`.
     */
    private static filterOnDatesRange(field: any, filterData: any, product: any, pool: any){
        let index: number = filterData.dates.indexOf(field);
        let startIndex: number = filterData.dates.indexOf(filterData.startDate);
        let endIndex: number = filterData.dates.indexOf(filterData.endDate);

        if (index >= startIndex && index <= endIndex) return true;

        return false;
    }
    /**
     * The function `updateNumberRanges` updates the minimum and maximum values for height, weight,
     * diameter, and volume based on the filtered products data.
     * @returns The `updateNumberRanges` function is not returning any value. It is a void function
     * that updates the number ranges for height, weight, diameter, and volume in the `Data.data`
     * object based on the filtered products in the `Data.data.filteredProducts` array.
     */
    public static updateNumberRanges(){
        if (!Data.data.filteredProducts) return;

        let heightRanges:any = Utils.copy(Data.data.height.range);
        let weightRanges:any = Utils.copy(Data.data.weight.range);
        let diameterRanges: any = Utils.copy(Data.data.diameter.range);
        let volumeRanges: any = Utils.copy(Data.data.volume.range);

        Data.data.height = { min:1000000, max:0, range:[0, 0] };
        Data.data.weight = { min: 1000000, max: 0, range: [0, 0] };
        Data.data.diameter = { min: 1000000, max: 0, range: [0, 0] };
        Data.data.volume = { min: 1000000, max: 0, range: [0, 0] };

        let a: number = Data.data.filteredProducts.length;
        for(let i=0; i<a; i++){
            let product: any = Data.data.filteredProducts[i];

            if (Data.data.height.max < product.height) Data.data.height.max = Data.data.height.range[1] = product.height;
            if (Data.data.height.min > product.height) Data.data.height.min = Data.data.height.range[0] = product.height;

            if (Data.data.weight.max < product.weight) Data.data.weight.max = Data.data.weight.range[1] = product.weight;
            if (Data.data.weight.min > product.weight) Data.data.weight.min = Data.data.weight.range[0] = product.weight;

            if (Data.data.diameter.max < product.diameter) Data.data.diameter.max = Data.data.diameter.range[1] = product.diameter;
            if (Data.data.diameter.min > product.diameter) Data.data.diameter.min = Data.data.diameter.range[0] = product.diameter;

            if (Data.data.volume.max < product.volume) Data.data.volume.max = Data.data.volume.range[1] = product.volume;
            if (Data.data.volume.min > product.volume) Data.data.volume.min = Data.data.volume.range[0] = product.volume;
        }

    }
}